module.exports = "build/assets/RingsideRegular-Light.23176443.ttf";